import React, { useRef, useState } from 'react';
import { useView } from '../../hooks/use-view';
import css from '../styles.module.css';
import { canInsert } from '../../utils';
import schema from '../../schema';

export const ImageButton = ({ onUpload, className, placeholder, children }) => {
  const view = useView();

  const ref = useRef<HTMLInputElement>(null);

  const [open, setOpen] = useState(false);

  const handleBtnClick = e => {
    e.preventDefault();
    if (view?.state) {
      ref.current?.click();
    }
  };

  return (
    <>
      <button
        className={className}
        onClick={handleBtnClick}
        placeholder={placeholder}
        disabled={view?.state && !canInsert(schema.nodes.image)(view.state)}
      >
        {children}
      </button>

      <div className={css.imageUpload}>
        <input
          type="file"
          ref={ref}
          onChange={onUpload}
          accept="image/*"
          multiple
        />
      </div>
    </>
  );
};
